import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ActionRequired from '../ActionRequired/ActionRequired';
import ActionCompleted from '../ActionCompleted/ActionCompleted';
import { getActions } from '../../services/action';
import IAction from '../../types/action';

export interface ITab {
  id: string;
  title: string;
}

const groupActions = (data: any[]) => {
  const result: Record<string, IAction> = {};
  for (let i = 0; i < data.length; i++) {
    const { actionId, actionName, contact, status, subStage } = data[i];
    if (!result[subStage]) result[subStage] = { id: i, name: subStage, dueDate: '', tasks: [] };
    result[subStage].tasks.push({
      id: actionId,
      name: actionName,
      assignee: `${contact.firstName} ${contact.lastName}`,
      status,
    });
  }
  return Object.values(result);
};

export const ActionTab = ({ id }: ITab) => {
  const [data, setData] = useState<IAction[]>();
  const [refresh, setRefresh] = useState(false);
  const toggleRefresh = () => {
    setRefresh(!refresh);
  };
  useEffect(() => {
    getActions({ task: id, langCode: 'en-us', lucidId: '234235235' }).then((response) =>
      setData(groupActions(response))
    );
  }, [id, refresh]);
  if (!data) return <>Loading...</>;
  if (id === 'COMPLETED') {
    return (
      <Box gap={1.25} display="flex" flexDirection="column" mt={2}>
        {data.map((action) => (
          <ActionCompleted key={action.id} {...action} />
        ))}
      </Box>
    );
  }
  return (
    <Box gap={1.25} display="flex" flexDirection="column" mt={2}>
      {data.map((action, i) => (
        <ActionRequired key={action.id} action={action} toggleRefresh={toggleRefresh} i={i} />
      ))}
    </Box>
  );
};
